<template>
  <select
    @change="$emit('input', $event.target.value)"
  >
    <option
      v-for="(option, i) in displayOptions"
      :key="i"
      :value="option.value"
      :selected="option.value == value"
    >
      {{ option.text }}
    </option>
  </select>
</template>

<script>
  export default {
    props: {
      value: [String, Number],
      options: Array,
    },
    computed: {
      displayOptions() {
        return this.options.map(option => {
          if (typeof option !== 'object')
            return { text: option, value: option };

          return option;
        });
      },
    },
  };
</script>

<style scoped>
  select {
    padding: 10px;
    font: inherit;
    background: #FFFFFF;
    border: 1px solid #CECECE;
    outline: none;
  }
</style>
